import { InventoryType } from "gen/ApiClient";

export const hasSize = (type: InventoryType) => {
    if (type === 'SkiBoot' || type === 'SnowboardBoot' || type === 'SkiBootTour') {
        return true;
    } else {
        return false;
    }
}